import { Pipe, PipeTransform } from '@angular/core';
import { genderIcons } from '@epicuro-next/constants/ui/icons';

@Pipe({
  name: 'genderIcon',
  standalone: true,
})
export class GenderIconPipe implements PipeTransform {
  transform(value: 'Mens' | 'Womens' | 'Unisex') {
    return genderIcons[value] ?? null;
  }
}
